module.exports = __webpack_public_path__ + "img/72.70ef8adf.png";